import _ from 'lodash';
import i18next from 'i18next';

import localeHelper from './helper';
import enGB from './en-GB.po';
import frFR from './fr-FR.po';

// Default locale
export const DEFAULT_LOCALE = 'en';

// Supported languages
// TODO
// When PO Editor answers to 26/12/2018 mail from Maxime Lebastard
// Load a global language file (ie. fr.po) with all the translations for a language
// and load regionalized files (ie. fr-BE.po) with a few exceptions.
// For a Belgian user, i18next will be able to get either translations from
// fr.po or fr-BE.po according to the priority
// https://www.i18next.com/principles/fallback
export const translations = {
  en: {
    translation: enGB,
  },
  fr: {
    translation: frFR,
  },
};

// Translator helper
export const getTranslator = () => i18next;

/**
 * Init locale and returns it as a string:
 *   e.g. en-gb or fr-ca
 * @param {String} locale: locale string
 *                         ([language]-[variant] or [language]_[variant])
 *                         both can be lower or upper case
 * @return {String} Normalized locale string.
 */
export const initLocale = async (locale) => {
  // Normalize en_GB to en-gb
  let appLocale = localeHelper.normalizeLocale(locale);

  // Set up I18next
  await localeHelper.setupI18Next(translations, appLocale, DEFAULT_LOCALE);

  // Set up Moment's global locale
  localeHelper.setMomentLocale(appLocale);

  return appLocale;
};




// WEBPACK FOOTER //
// ./src/locales/index.js